var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.72 15.0015C50.72 19.1393 49.0165 22.8873 46.2635 25.6056C45.2612 26.5936 44.1223 27.4425 42.8706 28.1198C40.6824 29.3212 38.1741 30.0031 35.5012 30.0031H30.4282L20.2824 20.0021H35.5012C38.2965 20.0021 40.5741 17.7569 40.5741 15.0015C40.5741 12.2462 38.2965 10.001 35.5012 10.001H10.1459L0 0H35.5059C43.9059 0 50.7247 6.71683 50.7247 15.0015H50.72Z",
    fill: "url(#paint0_linear_159_296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9985 45L42.8738 28.1198C40.6856 29.3212 38.1773 30.0031 35.5044 30.0031H30.4315L45.6503 45.0046H59.9985V45Z",
    fill: "url(#paint1_linear_159_296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1953 44.9991L0 4.39191V18.5353L26.8471 44.9991H41.1953Z",
    fill: "url(#paint2_linear_159_296)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_296",
    x1: 0.00000452462,
    y1: 0.228742,
    x2: 17.9669,
    y2: 39.4359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_296",
    x1: 28.3844,
    y1: 35.9051,
    x2: 48.3787,
    y2: 50.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_296",
    x1: 36.7448,
    y1: 40.8475,
    x2: 5.77334,
    y2: 0.292451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC346"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0830481433813a3cf7bceb756d07a65d.svg";
export { ForwardRef as ReactComponent };